import type {
    OrgEmployeeRequest,
    OrgEmployeeRequestsParams,
} from '@api/OrgEmployeeRequestService';
import { useOrgEmployeeRequestsEntry } from '@stores/orgEmployeeRequestStore';

const useOrgEmployeeRequests = (
    orgId: string,
    orgEmployeeId: string | undefined,
    params: OrgEmployeeRequestsParams = { state: 'ALL' },
): {
    orgEmployeeRequests: OrgEmployeeRequest[] | undefined;
    isLoadingOrgEmployeeRequests: boolean;
    fetchOrgEmployeeRequests: () => void;
} => {
    const {
        response: orgEmployeeRequests,
        isLoading: isLoadingOrgEmployeeRequests,
        requestApiCall: fetchOrgEmployeeRequests,
    } = useOrgEmployeeRequestsEntry(orgId, orgEmployeeId, params);

    return {
        orgEmployeeRequests,
        isLoadingOrgEmployeeRequests,
        fetchOrgEmployeeRequests,
    };
};

export default useOrgEmployeeRequests;
